import ColumnLink from "../../../../../../../components/_shared/ColumnLink/ColumnLink"

const columns = [
    {
        name: 'ID',
        selector: (row) => row?.id,
        sortable: true,
        sortField: 'id',
        width: '6%',
        cell: (row) => {
            // Get the Other Device category name
            const otherDeviceCategory = row?.categorization?.['1']?.category_name_tx || row?.other_devices_category_name_tx || '';
            // If category is "NewApp", link to categorize new app page, otherwise link to edit app page
            const linkTo = otherDeviceCategory === 'NewApp' 
                ? `/apps/categorize_new_app/${row?.id}` 
                : `/apps/editapps/${row?.id}`;
            return <ColumnLink text={row?.id} to={linkTo} />;
        },
    },
    {
        name: 'App Name',
        selector: (row) => row?.app_name_tx,
        sortable: true,
        sortField: 'app_name_tx',
        width: '8%',
    },
    {
        name: 'PlatForm',
        selector: (row) => row?.app_platform_tx,
        sortable: true,
        sortField: 'app_platform_tx',
        width: '8%',
    },
    {
        name: 'Package Name',
        selector: (row) => row?.app_package_name,
        sortable: true,
        sortField: 'app_package_name',
        width: '8%',
    },
    {
        name: 'First Seen',
        selector: (row) => row?.app_first_seen,
        sortable: true,
        sortField: 'app_first_seen',
        width: '8%',
    },
    {
        name: 'Group Name',
        selector: (row) => row?.app_group_name,
        sortable: true,
        sortField: 'app_group_name',
        width: '8%',
    },
    {
        name: 'Reviewer Notes',
        selector: (row) => row?.reviewer_notes,
        sortable: true,
        sortField: 'reviewer_notes',
        width: '8%',
    },
    {
        name: 'Date Modifier',
        selector: (row) => row?.date_modified,
        sortable: true,
        sortField: 'date_modified',
        width: '8%',
    },
    {
        name: (
        <table className="my-3" style={{ maxWidth: '400px', width: '100%' }}>
            <thead>
            <tr>
                <th
                colSpan="3"
                className="text-center"
                style={{ borderBottom: '0.2px solid var(--tableRowHoverColor)' }}
                >
                Other Device
                </th>
            </tr>
            <tr>
                <th style={{ width: '133px', paddingLeft: '15px' }}>Type</th>
                <th style={{ width: '133px' }}>Category</th>
                <th style={{ width: '133px' }}>Score Level</th>
            </tr>
            </thead>
        </table>
        ),
        cell: (row) => (
        <table style={{ maxWidth: '400px', width: '100%' }}>
            <tbody>
            <tr>
                <td style={{ width: '133px' }}>{row?.categorization?.['1']?.app_type_tx || row?.other_devices_app_type_tx || '-'}</td>
                <td style={{ width: '133px' }}>{row?.categorization?.['1']?.category_name_tx || row?.other_devices_category_name_tx || '-'}</td>
                <td style={{ width: '133px' }}>{row?.categorization?.['1']?.category_level_cd || row?.other_devices_category_level_cd || '-'}</td>
            </tr>
            </tbody>
        </table>
        ),
        width: '22%',
        style: {
            borderLeft: '0.5px solid var(--tableRowHoverColor)',
            borderRight: '0.5px solid var(--tableRowHoverColor)',
        },
    },
    {
        name: (
        <table className="my-3" style={{ maxWidth: '400px', width: '100%' }}>
            <thead>
            <tr>
                <th
                colSpan="3"
                className="text-center"
                style={{ borderBottom: '0.2px solid var(--tableRowHoverColor)' }}
                >
                Phone
                </th>
            </tr>
            <tr>
                <th style={{ width: '133px', paddingLeft: '15px' }}>Type</th>
                <th style={{ width: '133px' }}>Category</th>
                <th style={{ width: '133px' }}>Score Level</th>
            </tr>
            </thead>
        </table>
        ),
        cell: (row) => (
        <table style={{ maxWidth: '400px', width: '100%' }}>
            <tbody>
            <tr>
                <td style={{ width: '133px' }}>{row?.categorization?.['2']?.app_type_tx || row?.phones_app_type_tx || '-'}</td>
                <td style={{ width: '133px' }}>{row?.categorization?.['2']?.category_name_tx || '-'}</td>
                <td style={{ width: '133px' }}>{row?.categorization?.['2']?.category_level_cd || row?.phones_category_level_cd || '-'}</td>
            </tr>
            </tbody>
        </table>
        ),
            width: '16%',
            style: {
                borderLeft: '0.5px solid var(--tableRowHoverColor)',
                borderRight: '0.5px solid var(--tableRowHoverColor)',
            },
    },
]
const mobileColumns = [
    {
        name: 'ID',
        selector: (row) => row?.id,
        sortable: true,
        sortField: 'id',

        cell: (row) => {
            // Get the Other Device category name
            const otherDeviceCategory = row?.categorization?.['1']?.category_name_tx || row?.other_devices_category_name_tx || '';
            // If category is "NewApp", link to categorize new app page, otherwise link to edit app page
            const linkTo = otherDeviceCategory === 'NewApp' 
                ? `/apps/categorize_new_app/${row?.id}` 
                : `/apps/editapps/${row?.id}`;
            return <ColumnLink text={row?.id} to={linkTo} />;
        },
    },
    {
        name: 'App Name',
        selector: (row) => row?.app_name_tx,
        sortable: true,
        sortField: 'app_name_tx',
    },
]

export { columns, mobileColumns }
